"use strict";
exports.differenceInISOWeekYears = differenceInISOWeekYears;
var _index = require("./compareAsc.js");
var _index2 = require("./differenceInCalendarISOWeekYears.js");
var _index3 = require("./subISOWeekYears.js");
var _index4 = require("./toDate.js");
function differenceInISOWeekYears(dateLeft, dateRight) {
  let _dateLeft = (0, _index4.toDate)(dateLeft);
  const _dateRight = (0, _index4.toDate)(dateRight);
  const sign = (0, _index.compareAsc)(_dateLeft, _dateRight);
  const difference = Math.abs(
    (0, _index2.differenceInCalendarISOWeekYears)(_dateLeft, _dateRight)
  );
  _dateLeft = (0, _index3.subISOWeekYears)(_dateLeft, sign * difference);
  const isLastISOWeekYearNotFull = Number(
    (0, _index.compareAsc)(_dateLeft, _dateRight) === -sign
  );
  const result = sign * (difference - isLastISOWeekYearNotFull);
  return result === 0 ? 0 : result;
}
